import { parseText } from "./parseText.js";
export function parsePersonalNumber(source) {
    const value = parseText(source, 0, /^[A-Z0-9<]+<*$/);
    return {
        value,
        start: 0,
        end: value.length,
    };
}
//# sourceMappingURL=parsePersonalNumber.js.map